import React, { useState } from "react";
import AppSidebar from "@/components/AppSidebar";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Outlet } from "react-router-dom";

export function AppLayout() {
  const [isExpanded, setIsExpanded] = useState(true);

  const toggleSidebar = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="flex min-h-screen flex-col overflow-x-hidden w-full max-w-full">
      <Header />
      <div className="flex flex-1 w-full overflow-x-hidden pt-16">
        <div className={`hidden md:block ${isExpanded ? 'w-60' : 'w-14'} transition-all duration-300 border-r border-[#0f8f8c]/30`}>
          <AppSidebar isExpanded={isExpanded} onToggle={toggleSidebar} />
        </div>
        <main className="flex-1 py-4 px-2 md:px-4 bg-background overflow-x-hidden">
          <div className="w-full max-w-full overflow-hidden">
            <div className="page-header border-b-2 border-[#0f8f8c]/50 pb-4 mb-6">
              <Outlet />
            </div>
          </div>
        </main>
      </div>
      <Footer />
    </div>
  );
}
